// Note history, rebuilt from the journal. Restoring writes the old text as a new edit.

import { getSpace } from '../space/current';
import { titleOf } from '../notes/notes';
import { h, keep } from './dom';
import type { View } from './view';

export function historyView(root: HTMLElement, id: string): View {
  let alive = true;

  async function mount() {
    const space = await getSpace();
    if (!space || !alive) return;
    await space.notes.flush(); // the editor just closed: its last edits must be in the journal
    const versions = (await space.notes.history(id)).reverse();
    const name = (author: string) => space.journal.members.get(author)?.record.name ?? 'appareil inconnu';
    let selected = 0;

    const render = () => {
      const v = versions[selected];
      root.replaceChildren(
        ...keep(
          h('div', { class: 'row' }, h('a', { class: 'btn small', href: `#/notes/${id}`, text: '← Note' }), h('h1', { text: 'Historique' })),
          versions.length === 0 && h('p', { class: 'dim', text: 'Pas encore d’historique pour cette note.' }),
          versions.length > 0 &&
            h(
              'nav',
              { class: 'notes' },
              ...versions.map((ver, i) =>
                h(
                  'button',
                  { class: `note-row${i === selected ? ' selected' : ''}`, onclick: () => ((selected = i), render()) },
                  h('span', { class: 'note-main' }, h('span', { class: 'note-title', text: new Date(ver.ts).toLocaleString('fr-FR') }), h('span', { class: 'note-excerpt dim', text: `${name(ver.author)} · ${ver.text.length} caractères${i === 0 ? ' · version actuelle' : ''}` })),
                ),
              ),
            ),
          v && h('section', { class: 'card' }, h('h2', { text: titleOf({ title: v.fields.title, excerpt: v.text }) }), h('pre', { class: 'preview', text: v.text || '(vide)' })),
          v &&
            selected > 0 &&
            h('button', {
              class: 'btn primary',
              text: 'Restaurer cette version',
              onclick: async () => {
                await space.notes.restore(id, v.text);
                location.hash = `#/notes/${id}`;
              },
            }),
        ),
      );
    };
    render();
  }

  root.replaceChildren(h('p', { class: 'dim', text: 'Lecture de l’historique…' }));
  void mount();
  return {
    destroy() {
      alive = false;
    },
  };
}
